// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
} from "react-admin";

const BlogsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rechercher par Id" source="id" alwaysOn />
    <TextInput label="Rechercher par title" source="title" alwaysOn />
    <TextInput
      label="Rechercher par description"
      source="description"
      alwaysOn
    />
    <TextInput label="Rechercher par link" source="link" />
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const BlogsList = (props) => (
  <List {...props} filters={<BlogsFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="description" />
      <TextField source="link" />
      <TextField source="image" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const BlogsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="description" />
      <TextField source="link" />
      <TextField source="image" />
    </SimpleShowLayout>
  </Show>
);

export const BlogsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="title" />
      <TextInput source="description" />
      <TextInput source="link" />
      <TextInput source="image" />
    </SimpleForm>
  </Edit>
);
